import { AdvertiserLogo, useAdvertiserCampaignContext } from 'sonata-platform-components';

import { Advertiser } from '../types';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  advertiser: Partial<Advertiser>;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

export function AdvertiserLogoWrapper({ advertiser, user, userRoles }: Props) {
  const { mediaInfoDictionary, refetch } = useAdvertiserCampaignContext();

  return (
    <AdvertiserLogo
      mediaAdvertiser={advertiser}
      mediaInfoDictionary={mediaInfoDictionary || []}
      onMediaInfoDictionariesReload={refetch}
      user={user}
      userRoles={userRoles}
    />
  );
}
